import getApi from './getApi';

const urlPrefix = '/u2/console/music/';
export default {
    // 三方音乐列表
    musicList: getApi('get', `${urlPrefix}musicList`),
    // 删除
    musicDelete: getApi('get', `${urlPrefix}delete`),
    // 搜索歌曲
    musicSearch: getApi('get', `${urlPrefix}searchMusic`),
    // 添加音乐
    musicAdd: getApi('post', `${urlPrefix}addMusic`),
    // 栏目列表
    itemList: getApi('get', `${urlPrefix}itemList`),
    // 添加/修改栏目
    itemEdit: getApi('get', `${urlPrefix}itemEdit`),
    // 删除栏目
    itemDelete: getApi('get', `${urlPrefix}deleteItem`)
};